import { BrowserRouter, Routes, Route, Navigate } from 'react-router';
import { useAuthStore } from '@/stores/auth';
import { Login } from '@/pages/Login';
import { ForgotPassword } from '@/pages/ForgotPassword';
import { ResetPassword } from '@/pages/ResetPassword';
import { TenantShell } from '@/layouts/TenantShell';
import { Dashboard } from '@/pages/Dashboard';
import { Properties } from '@/pages/Properties';
import { CRM } from '@/pages/CRM';
import { Contracts } from '@/pages/Contracts';
import { Portals } from '@/pages/Portals';
import { Reports } from '@/pages/Reports';
import { Analytics } from '@/pages/Analytics';
import { Settings } from '@/pages/Settings';
import { Staff } from '@/pages/Staff';
import { Profile } from '@/pages/Profile';
import { MpListings } from '@/pages/MpListings';
import { MpCalendar } from '@/pages/MpCalendar';
import { MpCleaning } from '@/pages/MpCleaning';
import { MpRevenue } from '@/pages/MpRevenue';
import { MpCompliance } from '@/pages/MpCompliance';
import { ApplyForm } from '@/pages/ApplyForm';
import { TenantBilling } from '@/pages/TenantBilling';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isLoggedIn = useAuthStore((s) => s.isLoggedIn);
  return isLoggedIn ? <>{children}</> : <Navigate to="/login" replace />;
}

// Vite の BASE_URL（/tenant/ または /mock/tenant/）をそのまま basename に使用
const basename = import.meta.env.BASE_URL.replace(/\/$/, '');

export function AppRouter() {
  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route path="/apply/:token" element={<ApplyForm />} />
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/" element={<ProtectedRoute><TenantShell /></ProtectedRoute>}>
          <Route index element={<Navigate to="dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="properties" element={<Properties />} />
          <Route path="crm" element={<CRM />} />
          <Route path="contracts" element={<Contracts />} />
          <Route path="portals" element={<Portals />} />
          <Route path="reports" element={<Reports />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="settings" element={<Settings />} />
          <Route path="staff" element={<Staff />} />
          <Route path="profile" element={<Profile />} />
          <Route path="minpaku/listings" element={<MpListings />} />
          <Route path="minpaku/calendar" element={<MpCalendar />} />
          <Route path="minpaku/cleaning" element={<MpCleaning />} />
          <Route path="minpaku/revenue" element={<MpRevenue />} />
          <Route path="minpaku/compliance" element={<MpCompliance />} />
          <Route path="billing" element={<TenantBilling />} />
        </Route>
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
